exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myLogo {\n  border-bottom: 4px solid rgba(151, 151, 151, 0.24);\n  text-align: center; }\n  .myLogo a {\n    font: 300 \"NunitoSans\";\n    color: #4e4c4c; }\n\n.myBurger {\n  vertical-align: -webkit-baseline-middle;\n  margin-left: 20px;\n  color: #4e4c4c; }\n  .myBurger .i {\n    line-height: 50px; }\n\n@media (max-width: 768px) {\n  .myLogo a {\n    font-size: 29px;\n    height: 20px;\n    margin-right: 30px; } }\n\n.sidenav {\n  height: 100%;\n  width: 0;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  background-color: #111;\n  overflow-x: hidden;\n  transition: 0.5s;\n  padding-top: 60px; }\n\n.sidenav a {\n  padding: 8px 8px 8px 32px;\n  text-decoration: none;\n  font-size: 25px;\n  color: #818181;\n  display: block;\n  transition: 0.3s; }\n\n.sidenav a:hover {\n  color: #f1f1f1; }\n\n.sidenav .closebtn {\n  position: absolute;\n  top: 0;\n  right: 25px;\n  font-size: 36px;\n  margin-left: 50px; }\n\n@media screen and (max-height: 450px) {\n  .sidenav {\n    padding-top: 15px; }\n  .sidenav a {\n    font-size: 18px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/header/header.component.scss
// module id = ../../../../../src/app/header/header.component.scss
// module chunks = main